import React from "react";

interface CircularProgressCountProps {
	completed: number;
	total: number;
	size?: number;
}

export const CircularProgressCount: React.FC<CircularProgressCountProps> = ({
	completed,
	total,
	size = 24,
}) => {
	const remaining = total - completed;
	const percentage = total > 0 ? (completed / total) * 100 : 0;

	// SVG circle parameters
	const strokeWidth = 2.5;
	const radius = (size - strokeWidth) / 2;
	const circumference = 2 * Math.PI * radius;
	const offset = circumference - (percentage / 100) * circumference;

	// Font size based on circle size
	const fontSize = size * 0.45;

	return (
		<div className="relative" style={{ width: size, height: size }}>
			<svg
				width={size}
				height={size}
				className="transform -rotate-90"
			>
				{/* Background circle */}
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					fill="none"
					stroke="rgb(229, 231, 235)" // gray-200
					strokeWidth={strokeWidth}
				/>

				{/* Progress arc */}
				<circle
					cx={size / 2}
					cy={size / 2}
					r={radius}
					fill="none"
					stroke="rgb(37, 99, 235)" // blue-600
					strokeWidth={strokeWidth}
					strokeDasharray={circumference}
					strokeDashoffset={offset}
					strokeLinecap="round"
					className="transition-all duration-300 ease-out"
				/>
			</svg>

			{/* Number in center */}
			<div
				className="absolute inset-0 flex items-center justify-center text-gray-700 font-semibold"
				style={{ fontSize: `${fontSize}px` }}
			>
				{remaining}
			</div>
		</div>
	);
};
